<div class="flex grow h-full relative">
  <!-- Sidebar -->
  <div
    id="sidebar"
    data-drawer="true"
    data-drawer-overlay="true"
    data-drawer-direction="start"
    data-drawer-enable="true|lg:false"
    data-drawer-class="drawer drawer-start top-0 bottom-0"
    class="sidebar bg-light dark:bg-coal-600 z-20 border-r border-r-gray-200 dark:border-r-coal-100 flex flex-col items-stretch shrink-0 h-full overflow-y-auto"
  >
    <app-left-menu></app-left-menu>
  </div>
  <!-- <ec-secondary-nav></ec-secondary-nav> -->

  <!-- Main Content -->
  <div class="wrapper flex grow flex-col h-full overflow-hidden w-full">
    <!-- Header -->
    <!-- <app-header class=""></app-header> -->
    <div class="px-4 py-2 pt-3 w-full shrink-0 flex items-center">
      <!-- Burger menu button shown only on small screens (< 1024px) -->
      <button
        class="lg:hidden btn btn-icon btn-light btn-clear btn-sm me-2"
        (click)="toggleSidebar($event)"
      >
        <i class="ki-filled ki-menu text-xl"></i>
      </button>
      <app-breadcrumb class="grow"></app-breadcrumb>
    </div>

    <!-- Centered Content -->
    <div class="grow content overflow-y-auto w-full bg-gray dark:bg-coal-500">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
